export const Marquee = () => {
  const items = [
    "Aluminium Welding Cables",
    "Copper Welding Cables",
    "Industrial Welding Hoses",
    "Heavy Duty Engineered",
    "Precision Manufactured",
    "Made in India",
  ];
  const loop = [...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      className="bg-[#0E1116] border-y border-[#F5F1EA]/8 overflow-hidden py-6"
    >
      <div className="marquee-track flex items-center gap-14 whitespace-nowrap">
        {loop.map((item, i) => (
          <div key={i} className="flex items-center gap-14">
            <span className="font-serif italic font-medium tracking-wide text-2xl md:text-3xl text-[#F5F1EA]/80">
              {item}
            </span>
            <span className="text-brand-red text-xs">◆</span>
          </div>
        ))}
      </div>
    </section>
  );
};
